// extracted by mini-css-extract-plugin
export var eventCard = "event-summary-module--event-card--F5TbI";
export var eventDetails = "event-summary-module--event-details--vDkXA";
export var eventTime = "event-summary-module--event-time--e10pn";